import React, {useEffect, useRef, useState} from 'react'
import "./../../utils/Style/pages/Banktransfers.scss";
import TillsInput from "../../components/Branch/TillsInput";
import SupervisorsInput from "../../components/Branch/SupervisorsInput";
import useCommonAPI from "../../api/CommonAPI";
import MerchantInput from "../../components/Branch/MerchantInput";
import AddressInput from "../../components/Branch/AddressInput";
import {useDispatch} from "react-redux";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {useOutletContext} from "react-router-dom";
import {useToast} from "@chakra-ui/react";
import MerchantInformationAPI from "../../api/MerchantInformationAPI";

function NewBranchTemplate() {
    const {getAllRegions, regions} = useCommonAPI();

    const entityRole = sessionStorage.getItem("EntityRole");

    const {GetMerchantInformation, GetMerchantsInfoList, merchantLoading} = MerchantInformationAPI();

    const [portalBranchDTO, setPortalBranchDTO] = useState({
        "Name": "",
        "MerchantID": 0,
        "Description": "",
        "RegionID": 0,
        "MobileNo": "",
        "PhoneNo": "",
        "Longitude": 0,
        "Latitude": 0,
        "isVisible": true,
        "isOnline": false,
        "BranchEmployee": [],
        "tillReferences": []
    });

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!portalBranchDTO.Name) {
            newErrors.Name = "Branch Name is required.";
            isValid = false;
        }

        if (!portalBranchDTO.MerchantID) {
            newErrors.MerchantID = "Merchant is required.";
            isValid = false;
        }

        if ((!portalBranchDTO.isOnline && !portalBranchDTO.RegionID) || portalBranchDTO.RegionID==="-1") {
            newErrors.RegionID = "Region is required.";
            isValid = false;
        }

        if (!portalBranchDTO.isOnline && !portalBranchDTO.Description) {
            newErrors.Description = "Address is required.";
            isValid = false;
        }

        if (!portalBranchDTO.MobileNo) {
            newErrors.MobileNo = "Mobile Number is required.";
            isValid = false;
        }

        const regex = /^\+?\d{7,}$/
        if (portalBranchDTO.MobileNo && !regex.test(portalBranchDTO.MobileNo)) {
            newErrors.MobileNo = "Mobile Number format is incorrect.";
            isValid = false;
        }

        if (portalBranchDTO.PhoneNo && !regex.test(portalBranchDTO.PhoneNo)) {
            newErrors.PhoneNo = "Phone Number format is incorrect.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const [supervisors, setSupervisors] = useState([{EmployeeID: '-1', PhoneNo: ''}]);
    const [tills, setTills] = useState([{ReferenceNo: '', TypePOSValue: ''}]);
    const [errors, setErrors] = useState({});


    const handleRadioChange = (event) => {
        const {id} = event.target;
        setPortalBranchDTO((prevState) => ({
            ...prevState,
            isVisible: id === "Yes",
        }))
    };

    const [onOpenQrAfterGenerate] = useOutletContext();
    const dispatch = useDispatch();

    useEffect(() => {
        setPortalBranchDTO((prevState) => ({
            ...prevState,
            "BranchEmployee": supervisors
                .filter((supervisor) => !(supervisor.EmployeeID === '-1' && supervisor?.PhoneNo?.trim() === ''))
                .map((supervisor) => ({
                    "PhoneNo": supervisor.PhoneNumber,
                    ...supervisor,
                })),
            "tillReferences": tills
                .filter((till) => !(till.ReferenceNo?.trim() === ''))
        }));
    }, [supervisors, tills]);

    useEffect(()=>{
        setErrors({...errors, ["MerchantID"]: ""});
    }, [portalBranchDTO.MerchantID]);

    const containerRef = useRef(null);

    const handleSubmit = (event) => {
        if (validateForm()) {
            const payload = {
                portalBranchDTO: portalBranchDTO,
            }
            event.preventDefault();

            dispatch(setActionType(ACTION_TYPES.ADD_BRANCH));
            dispatch(setActionPayload(payload));

            onOpenQrAfterGenerate();
        } else {
            const container = containerRef.current;
            if (container) {
                container.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
    }

    useEffect(() => {
        getAllRegions();
        GetMerchantInformation();
    }, []);

    return (
        <div className="col-lg-12 col-sm-12">
            <div id="NewBranchesTemplate" ref={containerRef} style={{ height: '82vh', overflowY: 'auto', overflowX: 'hidden' }}>
                <div className="title">GENERAL INFORMATION</div>
                <div className="row mb-3">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="row component">
                            <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Branch</div>
                            <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                <input
                                    placeholder="Branch Name"
                                    onChange={(e) => {
                                        setPortalBranchDTO((prevState) => ({
                                            ...prevState,
                                            Name: e.target.value,
                                        }))
                                        setErrors({...errors, ["Name"]: ""});
                                    }
                                    }
                                />
                                {errors.Name && (
                                    <span className="error">{errors.Name}</span>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="row component">
                            <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Payment Options</div>
                            <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                <select
                                    className="ddselect"
                                    name="account"
                                    id="account"
                                    placeholder="Select"
                                    onChange={(e) => {
                                        setPortalBranchDTO((prevState) => ({
                                            ...prevState,
                                            isOnline: e.target.value === "online",
                                        }))
                                    }}
                                >
                                    <option value="pos">POS</option>
                                    <option value="online">Online</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-12 col-sm-12">
                        <div className="row component">
                            <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Show to Customers On Suyool</div>
                            <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                <div className="radio">
                                    <div className="radioCont">
                                        <label htmlFor="Yes">Yes</label>
                                        <input
                                            type="radio"
                                            id="Yes"
                                            defaultChecked
                                            onChange={handleRadioChange}
                                            name="Customers"
                                        />
                                    </div>
                                    <div className="radioCont">
                                        <label htmlFor="No">No</label>
                                        <input
                                            type="radio"
                                            id="No"
                                            name="Customers"
                                            onChange={handleRadioChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-3">

                    {GetMerchantsInfoList &&
                        <MerchantInput
                            portalBranchDTO={portalBranchDTO}
                            setPortalBranchDTO={setPortalBranchDTO}
                            options={GetMerchantsInfoList?.LegalEntityMerchantsInfoList}
                            type="add"
                            errors={errors}
                            setErrors={setErrors}
                        />}

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="row component">
                            <div className="col-lg-12 subTitle">Mobile Number</div>
                            <div className="col-lg-12 desc">
                                <input
                                    placeholder="Mobile Number"
                                    onChange={(e) => {
                                        setPortalBranchDTO((prevState) => ({
                                            ...prevState,
                                            MobileNo: e.target.value,
                                        }))
                                        setErrors({...errors, ["MobileNo"]: ""});
                                    }}
                                />
                                {errors.MobileNo && (
                                    <span className="error">{errors.MobileNo}</span>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="row component">
                            <div className="col-lg-12 subTitle">Phone Number</div>
                            <div className="col-lg-12 desc">
                                <input
                                    placeholder="Phone Number"
                                    onChange={(e) => setPortalBranchDTO((prevState) => ({
                                        ...prevState,
                                        PhoneNo: e.target.value,
                                    }))}
                                />
                                {errors.PhoneNo && (
                                    <span className="error">{errors.PhoneNo}</span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {!portalBranchDTO.isOnline ? (
                    <>
                        <div className="row mb-3">
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="row component">
                                    <div className="col-lg-12 subTitle">Region</div>
                                    <div className="col-lg-12 desc">
                                        <select
                                            className="ddselect"
                                            name="account"
                                            id="account"
                                            placeholder="Select"
                                            onChange={(e) => {
                                                setPortalBranchDTO((prevState) => ({
                                                    ...prevState,
                                                    RegionID: e.target.value,
                                                }))
                                                setErrors({...errors, ["RegionID"]: ""});
                                            }}
                                        >
                                            <option value={-1}>Select the Region</option>
                                            {regions.map(({label, value}) => (
                                                <option key={value} value={value}>{label}</option>
                                            ))}
                                        </select>
                                        {errors.RegionID && (
                                            <span className="error">{errors.RegionID}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className='col-lg-5 col-md-9 col-sm-12 map'>
                                <AddressInput portalBranchDTO={portalBranchDTO}
                                              setPortalBranchDTO={setPortalBranchDTO}/>

                            </div>
                        </div>

                        <TillsInput tills={tills} setTills={setTills}/>
                    </>
                ) : (
                    <></>
                )}


                {entityRole === "ADMIN" || entityRole === "SUPERADMIN"? (
                    <>
                        <div className="title">EMPLOYEES ACCESS - SUPERVISOR</div>
                        <SupervisorsInput supervisors={supervisors} setSupervisors={setSupervisors} mode="add"/>
                    </>
                ) : (<></>)}


                <div className='row'>
                    <div className='col-lg-3 col-sm-12'>
                        <button className='newBrachSubmit' onClick={handleSubmit}>Submit</button>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default NewBranchTemplate;